// import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import Instruction from "../../../../Assets/Images/Rounds/instruction.png";
import judge from "../../../../Assets/Images/Rounds/judge.png";
import markDistribution from "../../../../Assets/Images/Rounds/markDistributin.png";
import participant from "../../../../Assets/Images/Rounds/participant.png";
import result from "../../../../Assets/Images/Rounds/result.png";
import AuditionDragAndDrop from "../../AuditionPages/AuditionDragAndDrop/AuditionDragAndDrop";
import AuditionDescription from "../AuditionDescription/AuditionDescription";
import AuditionPay from "../AuditionPay/AuditionPay";
import AuditionMarkDistribution from "../content/AuditionMarkDistribution";
import AuditionResult from "../content/AuditionResult";
import JudgeCom from "../JudgeCom/JudgeCom";
import PendingAuditionCard from "../PendingAuditionCard/PendingAuditionCard";
import "./Round1com.css";

export default function Round1com({
  audition,
  roundInfo,
  instruction,
  is_video_uploaded,
}) {
  useEffect(() => {}, [roundInfo, instruction]);

  const [showPayment, setShowPayment] = useState(false);

  return (
    <div className="my-3">
      <Tab.Container fluid id="left-tabs-example" defaultActiveKey="first">
        <div className="round1">
          <Nav variant="pills">
            <div className="container-fluid ">
              <div className="d-sm-none d-md-flex justify-content-between flex-wrap">
                <div className="singleContent mb-2">
                  <div className="card roundCard1">
                    <div className="card-body">
                      <div className="text-center my-2">
                        <img src={participant} className="py-2" alt="" />
                      </div>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="first"
                          className="NavAudition subAudition"
                        >
                          Participation
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </div>
                </div>

                <div className="singleContent mb-2">
                  <div className="card roundCard1">
                    <div className="card-body">
                      <div className="text-center my-2">
                        <img src={Instruction} alt="" />
                      </div>
                      <div>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="second"
                            className="NavAudition subAudition"
                          >
                            Instruction
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="singleContent mb-2">
                  <div className="card roundCard1">
                    <div className="card-body">
                      <div className="text-center my-2">
                        <img src={judge} alt="" />
                      </div>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="judge"
                          className="NavAudition subAudition"
                        >
                          Judge
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </div>
                </div>

                <div className="singleContent mb-2">
                  <div className="card roundCard1">
                    <div className="card-body">
                      <div className="text-center my-2">
                        <img src={markDistribution} alt="" />
                      </div>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="fourth"
                          className="NavAudition subAudition"
                        >
                          Mark Distribution
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </div>
                </div>

                <div className="singleContent mb-2">
                  <div className="card roundCard1">
                    <div className="card-body">
                      <div className="text-center my-2">
                        <img src={result} alt="" />
                      </div>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="result"
                          className="NavAudition subAudition"
                        >
                          Result
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Nav>
        </div>

        <div className="container-fluid my-2">
          <Tab.Content>
            <Tab.Pane eventKey="first">
              {showPayment ? (
                <AuditionPay />
              ) : (
                <AuditionDragAndDrop
                  instruction={instruction}
                  roundInfo={roundInfo}
                  is_video_uploaded={is_video_uploaded}
                  showPayment={showPayment}
                  setShowPayment={setShowPayment}
                />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="second" className="bg-warning">
              <AuditionDescription
                instruction={instruction}
                roundInfo={roundInfo}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="judge">
              <JudgeCom audition={audition} />
            </Tab.Pane>

            <Tab.Pane eventKey="fourth">
              <AuditionMarkDistribution
                instruction={instruction}
                roundInfo={roundInfo}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="result">
              {roundInfo.manager_status == 2 ? (
                <>
                  <AuditionResult roundInfo={roundInfo} />
                </>
              ) : (
                <>
                  <PendingAuditionCard />
                </>
              )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </div>
  );
}
